import React from "react"
import { Box, BoxProps } from "@chakra-ui/react"

type Props = {
  placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end"
  offset?: BoxProps["top"]
} & BoxProps

// After Chakra UI v3's Float: centers its content on a corner of the positioned parent,
// offset moves it inward
const Float = ({ placement = "top-end", offset = 0, ...props }: Props) => {
  const [vertical, horizontal] = placement.split("-")

  return (
    <Box
      position="absolute"
      display="inline-flex"
      top={vertical === "top" ? offset : undefined}
      bottom={vertical === "bottom" ? offset : undefined}
      left={horizontal === "start" ? offset : undefined}
      right={horizontal === "end" ? offset : undefined}
      transform={`translate(${horizontal === "start" ? "-50%" : "50%"}, ${vertical === "top" ? "-50%" : "50%"})`}
      {...props}
    />
  )
}

export default Float
